(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusWithNoActiveProcessController', Controller);

    Controller.$inject = ['topBarService'];

    function Controller(topBarService) {
        topBarService.setTitleAndIcon('Action Plan Progress Tracking', 'fa fa-compass');
    }
})();